import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import "../assets/css/saharsh_style.css";
import "../assets/css/Responsive/saharsh_responsive.css";
import gall1 from "../assets/images/saharsh/saharsh.webp";
import gall2 from "../assets/images/saharsh/building1.webp";
import gall3 from "../assets/images/saharsh/balconyview.webp";
import gall4 from "../assets/images/saharsh/floor.webp";
import gall5 from "../assets/images/saharsh/gym.webp";
import gall6 from "../assets/images/saharsh/liberary.webp";
import ame4 from "../assets/images/saharsh/amenities/amenity4.webp";
import ame5 from "../assets/images/saharsh/amenities/amenity5.webp";
import ame16 from "../assets/images/saharsh/amenities/amenity16.webp";
import ame17 from "../assets/images/saharsh/amenities/amenity17.webp";
import ame18 from "../assets/images/saharsh/amenities/amenity18.webp";
import ame19 from "../assets/images/saharsh/amenities/amenity19.webp";
import ame20 from "../assets/images/saharsh/amenities/amenity20.webp";
import ame21 from "../assets/images/saharsh/amenities/amenity21.webp";
import ame22 from "../assets/images/saharsh/amenities/amenity22.webp";
import ame23 from "../assets/images/saharsh/amenities/amenity23.webp";
import ame24 from "../assets/images/saharsh/amenities/amenity24.webp";
import ame25 from "../assets/images/saharsh/amenities/amenity25.webp";
import ame26 from "../assets/images/saharsh/amenities/amenity26.webp";
import ame27 from "../assets/images/saharsh/amenities/amenity27.webp";
import ame28 from "../assets/images/saharsh/amenities/amenity28.webp";
import ame29 from "../assets/images/saharsh/amenities/amenity29.webp";
import ame30 from "../assets/images/saharsh/amenities/amenity30.webp";
import ame31 from "../assets/images/saharsh/amenities/amenity31.webp";
import ame32 from "../assets/images/saharsh/amenities/amenity32.webp";
import ame33 from "../assets/images/saharsh/amenities/amenity33.webp";
import ame34 from "../assets/images/saharsh/amenities/amenity34.webp";
// import rightimg from "../assets/images/saharsh/6.webp";
import spec1 from "../assets/images/saharsh/spec1.webp";
import spec2 from "../assets/images/saharsh/spec2.webp";
import spec3 from "../assets/images/saharsh/spec3.webp";
import spec4 from "../assets/images/saharsh/spec4.webp";
import spec5 from "../assets/images/saharsh/spec6.webp";
import spec6 from "../assets/images/saharsh/spec7.webp";

const images = [gall1, gall2, gall3, gall4, gall5, gall6];
const imags = [gall1, gall2, gall3, gall4, gall5, gall6];

export default function Saharsh() {
  const [modalImg, setModalImg] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
  });
  // const [showForm, setShowForm] = useState(false);
  const [showBrochureForm, setShowBrochureForm] = useState(false);
  const [showFloorPlanForm, setShowFloorPlanForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const openModal = (src) => {
    setModalImg(src);
  };

  const closeModal = () => {
    setModalImg(null);
  };

  document.title = "Sanvicasa - Project | Saharsh";

  const [showModal, setShowModal] = useState(false);

  const allAmenities = [
    { image: ame16, name: "Fully Equipped Gym" },
    { image: ame17, name: "Swing Seating Area" },
    { image: ame18, name: "Library" },
    { image: ame19, name: "Multipurpose Hall" },
    { image: ame20, name: "Kids Play Area" },
    { image: ame21, name: "Indoor Games" },
    { image: ame22, name: "Open Air Theater" },
    { image: ame5, name: "Meditation Area" },
    { image: ame24, name: "Gazebo" },
    { image: ame4, name: "Senior Citizen Sit-Out" },
    { image: ame23, name: "Pick Up & Drop Off Zone" },
    { image: ame25, name: "Walking Track" },
    { image: ame26, name: "Waiting Lounge" },
    { image: ame27, name: "Security Cabin" },
    { image: ame28, name: "Personal Foyer" },
    { image: ame29, name: "Society Office" },
    { image: ame30, name: "Ev Car Charging" },
    { image: ame31, name: "Fire Safety" },
    { image: ame32, name: "Solar Panel" },
    { image: ame33, name: "CCTV Camera" },
    { image: ame34, name: "24 HRS Water Supply" },

    // Add more amenities here if needed
  ];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000); // change every 4s
    return () => clearInterval(interval);
  }, []);

  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      video.currentTime = 9; // ⏩ start at 9s

      const checkTime = () => {
        if (video.currentTime >= 15) {
          // ⏹ stop at 15s
          video.currentTime = 9; // restart from 5s
        }
      };

      video.addEventListener("timeupdate", checkTime);
      return () => video.removeEventListener("timeupdate", checkTime);
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        videoRef.current.play();
      }
    });
    observer.observe(videoRef.current);
  }, []);

  return (
    <div>
      <div className="saharsh_container">
        <section className="saharsh_sec1" data-aos="fade-down">
          <div className="video-wrapper" data-aos="zoom-in">
            {/* <video autoPlay muted loop playsInline className="background-video">
              <source
                src={require("../assets/images/saharsh/home_video.mp4")}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video> */}
            <video
              ref={videoRef}
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
              className="background-video"
            >
              <source
                src={require("../assets/images/saharsh/home_video.webm")}
                type="video/webm"
              />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="projects">
            <div className="saharsh">
              <h1>sanvicasa saharsh</h1>
              <div className="proj-detail">
                <div className="first-det" data-aos="fade-right">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 24 24"
                    xmlSpace="preserve"
                    className="w-6 h-6"
                  >
                    <line
                      className="st0"
                      x1="14.9"
                      y1="6.7"
                      x2="14.9"
                      y2="15.1"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      className="st0"
                      x1="14.9"
                      y1="20.2"
                      x2="14.9"
                      y2="14.2"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      className="st0"
                      x1="14.9"
                      y1="14.2"
                      x2="18"
                      y2="15.7"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18,20.1V6.7c0-0.4-0.1-0.7-0.3-1c-0.7-0.6-1.5-1.1-2.3-1.6c-0.3-0.2-0.7-0.4-1.1-0.2L6.6,7.7
                    C6.2,8,5.9,8.4,5.8,8.9v7.4"
                      stroke="#FFFFFF"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      x1="5.9"
                      y1="12.2"
                      x2="14.9"
                      y2="9.3"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4,20.2v-2.4c0-0.6,0.3-1.1,0.8-1.3l1-0.2l9.1-2.1l0,0"
                      stroke="#FFFFFF"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18,9.3l1.7,1.7c0.3,0.3,0.4,0.6,0.4,1v8"
                      stroke="#FFFFFF"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      x1="21"
                      y1="20.2"
                      x2="3"
                      y2="20.2"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <p>2 & 3 BHK Flats & Shops</p>
                </div>
                <div className="sec-det" data-aos="fade-up">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 24 24"
                    xmlSpace="preserve"
                    className="w-6 h-6"
                  >
                    <line
                      x1="5.8"
                      y1="21"
                      x2="18.2"
                      y2="21"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <circle
                      cx="12"
                      cy="9.9"
                      r="2.8"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <path
                      d="M18.9,9.9C18.9,16.1,12,21,12,21S5.1,16.1,5.1,9.9C5.1,6.1,8.2,3,12,3S18.9,6.1,18.9,9.9z"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </svg>
                  <p>South Bopal Ahmedabad</p>
                </div>
                <div className="third-det" data-aos="fade-left">
                  <div class="progress-circle p100">
                    <span>60</span>
                    <div class="left-half-clipper">
                      <div class="first50-bar"></div>
                      <div class="value-bar"></div>
                    </div>
                  </div>
                  <p>Ready To Move In</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* section 2 */}
        <section className="saharsh_sec2" data-aos="fade-up">
          <div className="overview">
            <div className="tower-detail">
              <h3>2</h3>
              <p>Tower</p>
            </div>
            <div className="blocks">
              <h3>6 Wings</h3>
              <p>A B C D E F</p>
            </div>
            <div className="commercial-unit">
              <h3>29</h3>
              <p>Commercial Unit</p>
            </div>
            <div className="basement">
              <h3>2</h3>
              <p>Basement</p>
            </div>
            <div className="balcony">
              <h3>10 X 4</h3>
              <p>Proper sitting Balcony</p>
            </div>
            <div className="distance">
              <h3>80</h3>
              <p>feet distance between two towers</p>
            </div>
            <div className="apartment">
              <h3>304</h3>
              <p>Residential Apartment</p>
            </div>
            <div className="bhk">
              <h3>ALL</h3>
              <p>2 & 3 BHK</p>
            </div>
            <div className="rise-building">
              <h3>Low</h3>
              <p>14 Rise Building</p>
            </div>
            <div className="resident-size">
              <h3>Residential Size for 2 BHK</h3>
              <p>1400 sq ft</p>
            </div>
            <div className="resident-size">
              <h3>Residential Size for 3 BHK</h3>
              <p>1790 sq ft</p>
            </div>
            <div className="Commercial-Shops-Size">
              <h3>Commercial Shops Size</h3>
              <p>850 sq ft to 1500 sq ft</p>
            </div>
          </div>
          <p className="para-det">
            Precisely planned 2 & 3 BHK flats & shops mark an opulent arrival in
            one of the finest prime locality.
          </p>
          {/* <div className="overview-btns">
            <button>Brochure</button> */}
          <div className="overview-btns">
            <button onClick={() => setShowBrochureForm(true)}>Brochure</button>
            {/* <button onClick={() => setShowFloorPlanForm(true)}>
              Floor Plan
            </button> */}
            <Link to="/contact">
              <button>Contact Us</button>
            </Link>
          </div>

          {/* <button>Floor Plans</button>
          </div> */}
        </section>

        {/* section 3 */}
        <section className="saharsh_sec3">
          <h2 data-aos="fade-right">Gallery</h2>
          <h1 data-aos="fade-left">Space For Togetherness</h1>
          <div className="gallery-images">
            {images.map((src, index) => (
              <div
                className="img-wrapper"
                key={index}
                data-aos="zoom-in"
                data-aos-delay={index * 100}
              >
                <img
                  src={src}
                  alt={`Gallery ${index}`}
                  onClick={() => openModal(src)}
                />
              </div>
            ))}
          </div>
        </section>

        {/* Modal */}
        {modalImg && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-button" onClick={closeModal}>
                x
              </button>
              <img src={modalImg} alt="Full View" className="modal-img" />
            </div>
          </div>
        )}

        <section className="saharsh_sec4" data-aos="fade-up">
          <div className="outer">
            <div className="inner">
              <div className="left-inner">
                <div className="heading">
                  <p>
                    Amenities<div className="long-bar"></div>
                  </p>
                </div>
                <div className="amenities">
                  {allAmenities.slice(0, 6).map((amenity, index) => (
                    <div className="amenities-box" key={index}>
                      <div className={`ame${index + 1}`}>
                        <img src={amenity.image} alt={`Amenity${index + 1}`} />
                      </div>
                      <div className="ame-detail">
                        <p>{amenity.name}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <button onClick={() => setShowModal(true)}>
                  View All Amenities
                </button>
              </div>
              {/* <div className="right-inner">
                <img src={rightimg} alt="amenity-rightside" />
              </div> */}
              <div className="right-inner">
                <div
                  className="slider-track"
                  style={{ transform: `translateX(-${current * 100}%)` }}
                >
                  {imags.map((img, i) => (
                    <img key={i} src={img} alt={`slide-${i}`} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Modal */}
        {showModal && (
          <div
            className="amenities-modal-backdrop"
            onClick={() => setShowModal(false)}
          >
            <div
              className="amenities-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <h2 className="modal-heading">All Amenities</h2>
              <div className="modal-amenities-grid">
                {allAmenities.map((amenity, index) => (
                  <div className="amenities-box" key={index}>
                    <img src={amenity.image} alt={`Amenity${index + 1}`} />
                    <p>{amenity.name}</p>
                  </div>
                ))}
              </div>
              <button
                className="modal-close-btn"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}

        <section className="saharsh_sec5" data-aos="fade">
          <div className="specification" data-aos="fade-up">
            <div className="heading">
              <p>
                Specifications<div className="long-bar"></div>
              </p>
            </div>
          </div>
          <div className="specific-details">
            <div className="spec-box" data-aos="fade-right">
              <img src={spec1} alt="specification1" />
              <p>Flooring</p>
              <ul>
                <li>
                  Living, Dining- Premium Quality Vitrified Tiles 800x800mm
                </li>
                <li>
                  Bedrooms, Kitchen- Premium Quality Vitrified Tiles 600x600mm
                </li>
                <li> Porch, Wash - Rustic Tiles. Kota</li>
              </ul>
            </div>
            <div className="spec-box" data-aos="fade-left">
              <img src={spec2} alt="specification2" />
              <p>Kitchen</p>
              <ul>
                <li>Platform - Granite with SS Sink</li>
                <li>Tiles - Decorative Vitrified Tiles</li>
                <li>
                  Designer Vitrified Tiles dado Up to Lintel Level &amp; Wall
                  Above Kitchen Platform
                </li>
              </ul>
            </div>
            <div className="spec-box" data-aos="fade-right">
              <img src={spec3} alt="specification3" />
              <p>Bathrooms</p>
              <ul>
                <li>Wall - Decorative Vitrified Tiles</li>
                <li>Plumbing - Branded Concealed Bath Fittings</li>
                <li> Sanitary - Branded Table TOPS &amp; Wall Hung Commodes</li>
              </ul>
            </div>
            <div className="spec-box" data-aos="fade-left">
              <img src={spec4} alt="specification4" />
              <p>Doors</p>
              <ul>
                <li>Main Door - Designer Main Door with Wooden Frame</li>
                <li>
                  Internal Doors - Wooden Flush Doors With Premium Fittings
                </li>
              </ul>
            </div>
            <div className="spec-box" data-aos="fade-right">
              <img src={spec5} alt="specification5" />
              <p>Electric</p>
              <ul>
                <li>
                  All Areas - Concealed FR ISI Wiring with adequate number of
                  points in each room with branded Modular Switches.
                </li>
                <li>
                  AC provision in all bed rooms with concealed drain pipe and
                  copper cabling.
                </li>
              </ul>
            </div>
            <div className="spec-box" data-aos="fade-left">
              <img src={spec6} alt="specification6" />
              <p>Color</p>
              <ul>
                <li>Internal - Mala Plaster With Putty finish</li>
                <li>External - Double Coat mala Plaster with Texture finish</li>
              </ul>
            </div>
          </div>
        </section>
      </div>
      <div className="brochure">
        {/* Brochure Modal */}
        {showBrochureForm && (
          <div
            className="modal-overlay"
            onClick={() => setShowBrochureForm(false)}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h3>Request Brochure</h3>
              {submitted ? (
                <p>✅ Brochure will be sent to your email.</p>
              ) : (
                // <form
                //   onSubmit={(e) => {
                //     e.preventDefault();
                //     setSubmitted(true);
                //     setTimeout(() => {
                //       setShowBrochureForm(false);
                //       setSubmitted(false);
                //       setFormData({ name: "", email: "", contact: "" });
                //     }, 2000);
                //   }}
                // >
                //   <input
                //     type="text"
                //     placeholder="Your Name"
                //     value={formData.name}
                //     required
                //     onChange={(e) =>
                //       setFormData({ ...formData, name: e.target.value })
                //     }
                //   />
                //   <input
                //     type="email"
                //     placeholder="Your Email"
                //     value={formData.email}
                //     required
                //     onChange={(e) =>
                //       setFormData({ ...formData, email: e.target.value })
                //     }
                //   />
                //   <input
                //     type="tel"
                //     placeholder="Your Contact"
                //     value={formData.contact}
                //     maxLength={10}
                //     pattern="[0-9]{10}"
                //     required
                //     onChange={(e) => {
                //       const value = e.target.value;
                //       // Allow only numbers
                //       if (/^\d{0,10}$/.test(value)) {
                //         setFormData({ ...formData, contact: value });
                //       }
                //     }}
                //   />

                //   <button type="submit">Send Brochure</button>
                // </form>
                <form
                  onSubmit={async (e) => {
                    e.preventDefault();

                    const formDataToSend = new FormData();
                    formDataToSend.append(
                      "access_key",
                      "a78b83a8-b888-402a-ab79-9aea7f73fbad"
                    ); // 🔑 Replace with your Web3Forms key
                    formDataToSend.append("name", formData.name);
                    formDataToSend.append("email", formData.email);
                    formDataToSend.append("contact", formData.contact);
                    formDataToSend.append("message", "📘 Brochure Request");

                    try {
                      const response = await fetch(
                        "https://api.web3forms.com/submit",
                        {
                          method: "POST",
                          body: formDataToSend,
                        }
                      );

                      const result = await response.json();

                      if (result.success) {
                        Swal.fire({
                          icon: "success",
                          title: "Request Sent!",
                          text: "📘 Brochure will be sent to your email.",
                          confirmButtonColor: "#0a3d62",
                        });
                        setShowBrochureForm(false);
                        setFormData({ name: "", email: "", contact: "" });
                      } else {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong. Please try again.",
                        });
                      }
                    } catch (error) {
                      Swal.fire({
                        icon: "error",
                        title: "Network Error",
                        text: "Unable to connect. Please check your internet.",
                      });
                    }
                  }}
                >
                  <input
                    type="text"
                    placeholder="Your Name"
                    value={formData.name}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                  />
                  <input
                    type="email"
                    placeholder="Your Email"
                    value={formData.email}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                  <input
                    type="tel"
                    placeholder="Your Contact"
                    value={formData.contact}
                    maxLength={10}
                    pattern="[0-9]{10}"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        setFormData({ ...formData, contact: value });
                      }
                    }}
                  />

                  <button type="submit">Send Brochure</button>
                </form>
              )}
              <button
                className="close-btn"
                onClick={() => setShowBrochureForm(false)}
              >
                ✖
              </button>
            </div>
          </div>
        )}

        {/* Floor Plan Modal */}
        {showFloorPlanForm && (
          <div
            className="modal-overlay"
            onClick={() => setShowFloorPlanForm(false)}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h3>Request Floor Plan</h3>
              {submitted ? (
                <p>✅ Floor Plans will be sent to your email.</p>
              ) : (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setSubmitted(true);
                    setTimeout(() => {
                      setShowFloorPlanForm(false);
                      setSubmitted(false);
                      setFormData({ name: "", email: "", contact: "" });
                    }, 2000);
                  }}
                >
                  <input
                    type="text"
                    placeholder="Your Name"
                    value={formData.name}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                  />
                  <input
                    type="email"
                    placeholder="Your Email"
                    value={formData.email}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                  <input
                    type="tel"
                    placeholder="Your Contact"
                    value={formData.contact}
                    maxLength={10}
                    pattern="[0-9]{10}"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only numbers
                      if (/^\d{0,10}$/.test(value)) {
                        setFormData({ ...formData, contact: value });
                      }
                    }}
                  />

                  <button type="submit">Send Floor Plan</button>
                </form>
              )}
              <button
                className="close-btn"
                onClick={() => setShowFloorPlanForm(false)}
              >
                ✖
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
